(() => {
  if (window.HarrodDeliveryProgress) return;

  let generation = 0;
  let pending = false;
  let running = false;
  let timer;
  let retryTimer;
  let lastCount = '';
  const retryDelays = [500, 1500, 4000];
  const handledEvents = new WeakSet();
  const watchedBadges = new WeakSet();
  const countSignature = () => Array.from(document.querySelectorAll('[data-header-cart-count]'))
    .map(node => node.getAttribute('data-header-cart-count')).join(',');

  function render(status) {
    const header = status?.querySelector('[data-ho-delivery-header-template]');
    if (!header) return false;
    const toast = status.querySelector('[data-ho-delivery-toast-template]');
    document.querySelectorAll('[data-ho-header-delivery-content]').forEach(host => {
      host.innerHTML = header.innerHTML;
    });
    if (toast) document.querySelectorAll('[data-ho-toast-delivery]').forEach(host => {
      host.innerHTML = toast.innerHTML;
      host.hidden = !host.firstElementChild;
    });
    lastCount = countSignature();
    return true;
  }

  function schedule(delay = 80) {
    generation += 1;
    pending = true;
    clearTimeout(timer);
    clearTimeout(retryTimer);
    if (!running) timer = setTimeout(() => refresh(), delay);
  }

  async function refresh(attempt = 0) {
    clearTimeout(timer);
    if (running) { schedule(); return; }
    const link = document.querySelector('.ho-header-delivery');
    if (!link || !document.querySelector('[data-ho-header-delivery-content]')) return;
    const started = generation;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    pending = false;
    running = true;
    try {
      const url = new URL(link.getAttribute('href'), location.origin);
      // Render the section from the locale root; /cart can return cart JSON.
      url.pathname = url.pathname.replace(/\/cart\/?$/, '/');
      url.search = '';
      url.hash = '';
      url.searchParams.set('sections', 'ho-cart-status');
      url.searchParams.set('_ho_cart_refresh', String(Date.now()));
      const response = await fetch(url.toString(), {
        credentials: 'same-origin', cache: 'no-store', signal: controller.signal
      });
      if (!response.ok) throw new Error('Delivery progress unavailable');
      const sections = await response.json();
      if (started !== generation) return;
      const status = new DOMParser().parseFromString(sections['ho-cart-status'] || '', 'text/html')
        .querySelector('[data-ho-cart-status]');
      if (!render(status)) throw new Error('Delivery progress unavailable');
    } catch (_) {
      if (started === generation && attempt < retryDelays.length) {
        retryTimer = setTimeout(() => refresh(attempt + 1), retryDelays[attempt]);
      }
    } finally {
      clearTimeout(timeout);
      running = false;
      if (pending) timer = setTimeout(() => refresh(), 0);
    }
  }

  function onCartChange(event) {
    if (handledEvents.has(event) || event.detail?.success === false) return;
    handledEvents.add(event);
    schedule();
  }

  // External pickers may finish out of order. Always read the current basket.
  window.HarrodDeliveryProgress = {
    update: () => { schedule(); return true; },
    refresh: () => { schedule(0); }
  };

  function start() {
    const observer = new MutationObserver(() => {
      const count = countSignature();
      if (count !== lastCount) { lastCount = count; schedule(); }
    });
    function watchBadges() {
      document.querySelectorAll('[data-header-cart-count]').forEach(badge => {
        if (watchedBadges.has(badge)) return;
        watchedBadges.add(badge);
        observer.observe(badge, { attributes: true, attributeFilter: ['data-header-cart-count'] });
      });
    }
    watchBadges();
    lastCount = countSignature();
    ['cartcount:update', 'addToCartFlyout:complete', 'cart:updated', 'cart:update',
      'cart:change', 'cart:refresh', 'ajaxCart:added', 'ho:product-added',
      'ho:planting-extras-cart-updated'].forEach(name => {
      document.addEventListener(name, onCartChange);
      window.addEventListener(name, onCartChange);
    });
    document.addEventListener('shopify:section:load', () => { watchBadges(); schedule(); });
    window.addEventListener('online', () => schedule());
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') schedule();
    });
    window.addEventListener('pageshow', event => { if (event.persisted) schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

